import theme from 'config/theme';

export default {
  section: {
    marginBottom: '16px',
  },
  row: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(200px, 1fr))',
    rowGap: '20px',
    columnGap: '12px',
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
};
